import ModalFactory from '../factory';

import Content from './DialerModal';

const DialerModal = ModalFactory(Content);

export default DialerModal;
